import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const ConfigContext = createContext(null);

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    api.get("/config").then((res) => setConfig(res.data)).catch(() => setConfig({}));
  }, []);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return useContext(ConfigContext) || {};
}
